import { gql } from 'graphql-request'

export const REMOVE_NEWS = gql`
  mutation RemoveNews($removeNewsId: Int!) {
    removeNews(id: $removeNewsId) {
      deletedAt
    }
  }
`
